import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { OrderReturnEditPage } from 'src/app/modals/order-return-edit/order-return-edit.page';

const routes: Routes = [
  {
    path: '',
    component: OrderReturnEditPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OrderReturnEditPage]
})
export class OrderReturnEditPageModule {}
